module.exports = __webpack_public_path__ + "static/04-7bb6eb38a4646c6bbfefb51b3cf890de.jpg";